import GLightbox from "glightbox";

/**
 * Initializes the lightbox functionality for core gallery blocks.
 * Automatically wraps unlinked images and initializes GLightbox.
 */
export default function initLightbox() {
  const galleries = document.querySelectorAll(".wp-block-gallery");

  galleries.forEach((gallery, index) => {
    const images = gallery.querySelectorAll(".wp-block-image img");
    const galleryId = `gallery-${index}`;

    images.forEach((img) => {
      let trigger = img.closest("a");

      if (!trigger) {
        trigger = document.createElement("a");
        trigger.href = img.src;
        trigger.className = "glightbox";
        img.parentNode.insertBefore(trigger, img);
        trigger.appendChild(img);
      } else {
        trigger.classList.add("glightbox");
      }

      trigger.setAttribute("data-gallery", galleryId);

      const caption = img.closest("figure").querySelector("figcaption");
      if (caption) {
        trigger.setAttribute("data-description", caption.innerText);
      }
    });
  });

  GLightbox({
    selector: ".glightbox",
    touchNavigation: true,
    loop: true,
    zoomable: true,
  });
}
